
        (function() {
            const track = document.getElementById('galleryTrack');
            const items = document.querySelectorAll('.gallery-item');
            const prevBtn = document.getElementById('galPrev');
            const nextBtn = document.getElementById('galNext');
            const dotsContainer = document.getElementById('galDots');
            if (!track || !prevBtn || !nextBtn || !dotsContainer) return;

            const total = items.length;
            let current = 0;

            function renderDots() {
                dotsContainer.innerHTML = '';
                for (let i = 0; i < total; i++) {
                    const dot = document.createElement('button');
                    dot.className = 'w-2.5 h-2.5 rounded-full transition-all gallery-dot ' +
                        (i === current ? 'bg-teal w-6' : 'bg-slate-300 hover:bg-slate-400');
                    dot.onclick = () => goTo(i);
                    dotsContainer.appendChild(dot);
                }
            }

            function goTo(idx) {
                current = (idx + total) % total;
                track.style.transform = 'translateX(-' + (current * 100) + '%)';
                renderDots();
            }

            prevBtn.onclick = () => goTo(current - 1);
            nextBtn.onclick = () => goTo(current + 1);

            let startX = 0;
            track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
            track.addEventListener('touchend', e => {
                const diff = startX - e.changedTouches[0].clientX;
                if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
            }, { passive: true });
            renderDots();

            const lightbox = document.getElementById('galLightbox');
            const lbImage = document.getElementById('lbImage');
            const lbCounter = document.getElementById('lbCounter');
            const lbDotsContainer = document.getElementById('lbDots');
            const lbClose = document.getElementById('lbClose');
            const lbPrev = document.getElementById('lbPrev');
            const lbNext = document.getElementById('lbNext');
            if (!lightbox || !lbImage) return;

            const srcs = Array.from(items).map(img => img.src);
            let lbIdx = 0;

            function renderLbDots() {
                if (!lbDotsContainer) return;
                lbDotsContainer.innerHTML = '';
                for (let i = 0; i < total; i++) {
                    const dot = document.createElement('button');
                    dot.className = 'w-2 h-2 rounded-full transition-all border border-teal lb-dot ' +
                        (i === lbIdx ? 'bg-teal w-5' : 'bg-white/30 hover:bg-white/50');
                    dot.onclick = () => lbGoTo(i);
                    lbDotsContainer.appendChild(dot);
                }
            }

            function lbGoTo(idx) {
                lbIdx = (idx + total) % total;
                lbImage.src = srcs[lbIdx];
                if (lbCounter) lbCounter.textContent = (lbIdx + 1) + ' / ' + total;
                renderLbDots();
            }

            function openLb(idx) {
                lbGoTo(idx);
                lightbox.classList.remove('hidden');
                document.body.style.overflow = 'hidden';
            }

            function closeLb() {
                lightbox.classList.add('hidden');
                document.body.style.overflow = '';
            }

            items.forEach(img => {
                img.onclick = () => openLb(parseInt(img.dataset.idx, 10));
            });
            if (lbClose) lbClose.onclick = closeLb;
            lightbox.onclick = e => { if (e.target === lightbox) closeLb(); };
            if (lbPrev) lbPrev.onclick = () => lbGoTo(lbIdx - 1);
            if (lbNext) lbNext.onclick = () => lbGoTo(lbIdx + 1);

            document.addEventListener('keydown', e => {
                if (lightbox.classList.contains('hidden')) return;
                if (e.key === 'Escape') closeLb();
                if (e.key === 'ArrowLeft') lbGoTo(lbIdx - 1);
                if (e.key === 'ArrowRight') lbGoTo(lbIdx + 1);
            });

            let lbStartX = 0, lbStartY = 0;
            lightbox.addEventListener('touchstart', e => {
                lbStartX = e.touches[0].clientX;
                lbStartY = e.touches[0].clientY;
            }, { passive: true });
            lightbox.addEventListener('touchend', e => {
                const diffX = lbStartX - e.changedTouches[0].clientX;
                const diffY = lbStartY - e.changedTouches[0].clientY;
                if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 60) {
                    lbGoTo(diffX > 0 ? lbIdx + 1 : lbIdx - 1);
                } else if (diffY < -80) {
                    closeLb();
                }
            }, { passive: true });
        })();

        (function() {
            const reviewImgs = document.querySelectorAll('.review-img');
            const reviewLightbox = document.getElementById('reviewLightbox');
            const reviewLightboxImg = document.getElementById('reviewLightboxImg');
            const reviewLightboxUser = document.getElementById('reviewLightboxUser');
            const reviewLightboxStars = document.getElementById('reviewLightboxStars');
            const reviewLightboxCounter = document.getElementById('reviewLightboxCounter');
            const reviewLightboxDots = document.getElementById('reviewLightboxDots');
            const reviewLightboxClose = document.getElementById('reviewLightboxClose');
            const reviewLightboxPrev = document.getElementById('reviewLightboxPrev');
            const reviewLightboxNext = document.getElementById('reviewLightboxNext');
            const reviewLightboxCTA = document.getElementById('reviewLightboxCTA');
            if (!reviewLightbox || !reviewLightboxImg || !reviewImgs.length) return;

            const reviewData = Array.from(reviewImgs).map(el => ({
                src: el.querySelector('img').src,
                user: el.dataset.user,
                rating: parseInt(el.dataset.rating, 10) || 5
            }));
            let reviewIndex = 0;

            function generateStars(rating) {
                let stars = '';
                for (let i = 0; i < 5; i++) {
                    stars += i < rating
                        ? '<i class="fas fa-star text-sm"></i>'
                        : '<i class="fa-regular fa-star text-sm"></i>';
                }
                return stars;
            }

            function updateReviewLightbox() {
                const data = reviewData[reviewIndex];
                reviewLightboxImg.src = data.src;
                if (reviewLightboxUser) reviewLightboxUser.textContent = data.user;
                if (reviewLightboxStars) reviewLightboxStars.innerHTML = generateStars(data.rating);
                if (reviewLightboxCounter) {
                    reviewLightboxCounter.textContent = (reviewIndex + 1) + ' / ' + reviewData.length;
                }
                if (reviewLightboxDots) {
                    reviewLightboxDots.innerHTML = reviewData.map((_, i) =>
                        '<button class="w-2 border border-teal h-2 rounded-full ' +
                        (i === reviewIndex ? 'bg-teal' : 'bg-white/30') +
                        ' transition-all" data-ri="' + i + '"></button>'
                    ).join('');
                    reviewLightboxDots.querySelectorAll('button').forEach(btn => {
                        btn.onclick = () => {
                            reviewIndex = parseInt(btn.dataset.ri, 10);
                            updateReviewLightbox();
                        };
                    });
                }
            }

            function openReviewLightbox(index) {
                reviewIndex = index;
                updateReviewLightbox();
                reviewLightbox.classList.remove('hidden');
                document.body.style.overflow = 'hidden';
            }

            function closeReviewLightbox() {
                reviewLightbox.classList.add('hidden');
                document.body.style.overflow = '';
            }

            reviewImgs.forEach((el, i) => {
                el.addEventListener('click', () => openReviewLightbox(i));
            });
            if (reviewLightboxClose) reviewLightboxClose.addEventListener('click', closeReviewLightbox);
            reviewLightbox.addEventListener('click', e => {
                if (e.target === reviewLightbox) closeReviewLightbox();
            });
            if (reviewLightboxCTA) reviewLightboxCTA.addEventListener('click', closeReviewLightbox);
            if (reviewLightboxPrev) {
                reviewLightboxPrev.addEventListener('click', () => {
                    reviewIndex = (reviewIndex - 1 + reviewData.length) % reviewData.length;
                    updateReviewLightbox();
                });
            }
            if (reviewLightboxNext) {
                reviewLightboxNext.addEventListener('click', () => {
                    reviewIndex = (reviewIndex + 1) % reviewData.length;
                    updateReviewLightbox();
                });
            }

            document.addEventListener('keydown', e => {
                if (reviewLightbox.classList.contains('hidden')) return;
                if (e.key === 'Escape') closeReviewLightbox();
                if (e.key === 'ArrowLeft' && reviewLightboxPrev) reviewLightboxPrev.click();
                if (e.key === 'ArrowRight' && reviewLightboxNext) reviewLightboxNext.click();
            });

            let rTouchStartX = 0, rTouchStartY = 0;
            reviewLightbox.addEventListener('touchstart', e => {
                rTouchStartX = e.touches[0].clientX;
                rTouchStartY = e.touches[0].clientY;
            }, { passive: true });
            reviewLightbox.addEventListener('touchend', e => {
                const diffX = rTouchStartX - e.changedTouches[0].clientX;
                const diffY = rTouchStartY - e.changedTouches[0].clientY;
                if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
                    if (diffX > 0 && reviewLightboxNext) reviewLightboxNext.click();
                    else if (reviewLightboxPrev) reviewLightboxPrev.click();
                } else if (diffY < -80) {
                    closeReviewLightbox();
                }
            }, { passive: true });
        })();

        function toggleFaq(btn) {
            const item = btn.closest('.faq-item');
            const content = item.querySelector('.faq-content');
            const allItems = document.querySelectorAll('.faq-item');
            allItems.forEach(i => {
                if (i !== item) {
                    i.classList.remove('active');
                    i.querySelector('.faq-content').classList.add('hidden');
                }
            });
            item.classList.toggle('active');
            content.classList.toggle('hidden');
        }
    
